/* eslint-disable no-useless-escape */
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import {
  MAGALU_FB_PIXEL_ID,
  ITAU_FB_PIXEL_ID,
  IS_VWO_ENABLED
} from 'gatsby-env-variables'

import {
  If,
  Footer,
  Header,
  Feedback,
  CookieBar
} from '@itau-loans-www/components'
import { sdkAnalytics } from '@itau-loans-www/services'
import { getProduct, isOrganic } from '@itau-loans-www/utils'
import { useLocation } from '@reach/router'
import routes from 'Routes'

const metaData = {
  consignado: {
    description:
      'Contrate aqui seu empréstimo consignado com as melhores taxas! Crédito até para negativado. INSS, servidores e empresa privada. Na sua conta em até 24 horas.'
  },
  fgts: {
    description:
      'Mesmo para negativados, até 7 parcelas do seu FGTS e o dinheiro cai na sua conta em até 24 horas. Consulte o seu saldo e antecipe com a gente.'
  }
}

const isToRefreshTitle = (product = '', path = '', currentPath) => {
  const fullPathKey = isOrganic ? `${product}:organic` : product
  const isToGetFullPath = BUILD_ENV !== 'e2e'

  const fullPath = {
    fgts: '/saque-aniversario-fgts',
    consignado: '/emprestimo-consignado',
    'fgts:organic': '/emprestimos-financiamentos/saque-aniversario-fgts',
    'consignado:organic':
      '/emprestimos-financiamentos/emprestimo-consignado-itau'
  }

  const cleanUrl = (url) => (url === '/' ? url : url.replace(/\/$/, ''))

  const fullPathName = fullPath[fullPathKey] ?? ''

  const pathValue = isToGetFullPath ? fullPathName + path : path

  const pathValueCleaned = cleanUrl(pathValue)
  const currentPathCleaned = cleanUrl(currentPath)

  return pathValueCleaned === currentPathCleaned
}

export default ({
  children,
  hasFooter,
  isLanding,
  currentPage,
  partnerName,
  hasCookieBar = true
}) => {
  const location = useLocation()
  const currentPath = location?.pathname
  const productName = getProduct()

  const [title, setTitle] = useState(
    'Empréstimo Pessoal Online | Simule agora | Itaú'
  )

  useEffect(() => {
    for (const [key, value] of Object.entries(routes)) {
      if (isToRefreshTitle(productName, value?.path, currentPath)) {
        setTitle(value?.title)
        sdkAnalytics.track('trackScreenView', key)
      }
    }
  }, [currentPath, productName])

  const htmlAttributes = {
    lang: 'pt-br'
  }

  // TO DO:
  // quando for para remover os scripts do FB,
  // criar um hooks.js e uma pasta components pra organizar melhor aqui

  return (
    <>
      <Helmet htmlAttributes={htmlAttributes}>
        <meta charSet="utf-8" />
        <meta name="description" content={metaData[productName].description} />
        <title>{title}</title>

        <link
          rel="preconnect"
          as="script"
          href="https://www.googletagmanager.com"
          fetchpriority="low"
        />
        <link
          rel="preconnect"
          as="script"
          href="https://www.facebook.com"
          fetchpriority="low"
        />
        <link
          rel="preconnect"
          as="script"
          href="https://www.google-analytics.com"
          fetchpriority="low"
        />
        <link
          rel="preconnect"
          as="script"
          href="https://connect.facebook.net/"
          fetchpriority="low"
        />
        <link
          rel="preconnect"
          as="script"
          href="https://www.itau.com.br/"
          fetchpriority="low"
        />
        {/* <!-- Facebook Pixel Code --> */}
        <script>
          {partnerName === 'magalu' &&
            `!function(f,b,e,v,n,t,s){
             if(f.fbq)return;n=f.fbq=function(){n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
             if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
             n.queue=[];t=b.createElement(e);t.async=!0;
             t.src=v;s=b.getElementsByTagName(e)[0];
             s.parentNode.insertBefore(t,s)}(window, document,'script',
             'https://connect.facebook.net/en_US/fbevents.js');
             fbq('init', ${MAGALU_FB_PIXEL_ID});
             fbq('track', 'PageView');`}
        </script>
        <noscript>
          {partnerName === 'magalu' &&
            `<img width="1" height="1" style="display:none"
                src="https://www.facebook.com/tr?id=${MAGALU_FB_PIXEL_ID}&ev=PageView&noscript=1"/>`}
        </noscript>

        <script>{`!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${ITAU_FB_PIXEL_ID}');
        fbq('track', 'PageView');`}</script>

        <noscript>
          {`<img height="1" width="1" style="display:none" 
          src="https://www.facebook.com/tr?id=${ITAU_FB_PIXEL_ID}&ev=PageView&noscript=1"/>`}
        </noscript>

        {/* <!-- End Facebook Pixel Code --> */}

        {/* <!-- Start VWO Async SmartCode --> */}
        {IS_VWO_ENABLED && (
          <link
            rel="preconnect"
            href="https://dev.visualwebsiteoptimizer.com"
          />
        )}
        {IS_VWO_ENABLED && (
          <script type="text/javascript" id="vwoCode">
            {`
              window._vwo_code || (function() {
              var account_id=839896,
              version=2.0,
              settings_tolerance=2000,
              hide_element='body',
              hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
              /* DO NOT EDIT BELOW THIS LINE */
              f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();
            `}
          </script>
        )}
        {/* <!-- End VWO Async SmartCode --> */}

        {/* Google Search Console Meta Tag */}
        <meta
          name="google-site-verification"
          content="sBFYXb1uG6G4qTq1MsCk5-964HrcRNTnYvpL98T7UNc"
        />
      </Helmet>

      <Feedback />

      <If condition={hasCookieBar} renderIf={<CookieBar />} />
      <Header
        isLanding={isLanding}
        currentPage={currentPage}
        partnerName={partnerName}
      />
      {children}
      <If condition={hasFooter} renderIf={<Footer />} />
    </>
  )
}
